import React from 'react';
import { PdsIconLoader } from "@principal/design-system-icons-react";

export type LoadingSpinnerProps = {
    spinnerText?: string,
    children?: React.ReactNode
}

const LoadingSpinner = (props: LoadingSpinnerProps) => {
    return (
        <div><PdsIconLoader className="fa-spin pds-u-inline-block"/> {props.spinnerText}</div>
    )
};
export default LoadingSpinner;